import "shad/tailwind.css";
import "ui/base/custom.css";
import { Route, Routes } from "react-router";
import { LeadApp } from "./leads/Lead";

export function App() {
  return (
    <Routes>
      <Route path="" element={<LeadApp />} />
    </Routes>
  );
}
